import React from "react";

const Error: React.FC = () => (
  <div className="container">
    <h1>Něco se pokazilo</h1>
  </div>
);

export default Error;
